import type { ISpread } from "../spreadsSlice";
import { threeCardsSpread } from "./spreads/threeCards";
import { oneCardSpread } from "./spreads/oneCard";
import { celticCrossSpread } from "./spreads/celticCross";
import { twoCardsSpread } from "./spreads/twoCards";
import { crossChoiceSpread } from "./spreads/crossChoice";
import { choicePathSpread } from "./spreads/choicePath";
import { situationPotentialSpread } from "./spreads/situationPotential";
import { situationDevelopmentSpread } from "./spreads/situationDevelopment";
import { psychologicalCircleSpread } from "./spreads/psychologicalCircle";
import { psychologicalLifeProfileSpread } from "./spreads/psychologicalLifeProfile";
import { relationshipsSpread } from "./spreads/relationships";
import { periodicForecastSpread } from "./spreads/periodicForecast";
import { yearlySpread } from "./spreads/yearly";
import { treeOfLifeSpread } from "./spreads/treeOfLife";

export const spreadsData: ISpread[] = [
  threeCardsSpread,
  oneCardSpread,
  celticCrossSpread,
  twoCardsSpread,
  crossChoiceSpread,
  choicePathSpread,
  situationPotentialSpread,
  situationDevelopmentSpread,
  psychologicalCircleSpread,
  psychologicalLifeProfileSpread,
  relationshipsSpread,
  periodicForecastSpread,
  yearlySpread,
  treeOfLifeSpread,
];

export const validateSpreadsData = (
  spreads: ISpread[]
): void => {
  const spreadIds = new Set<string>();

  spreads.forEach((spread) => {
    const spreadId = spread.id.trim();

    if (!spreadId) {
      throw new Error("Обнаружен расклад без spread.id");
    }

    if (spreadIds.has(spreadId)) {
      throw new Error(`Повторяющийся spread.id: "${spreadId}"`);
    }

    spreadIds.add(spreadId);

    if (spread.cardsCount !== spread.positions.length) {
      throw new Error(
        `Расклад "${spread.id}": cardsCount=${spread.cardsCount}, ` +
          `positions.length=${spread.positions.length}`
      );
    }

    const positionIds = new Set<string>();

    spread.positions.forEach((position, index) => {
      const positionId = position.id.trim();

      if (!positionId) {
        throw new Error(
          `Расклад "${spread.id}": позиция ${index + 1} не имеет position.id`
        );
      }

      if (positionIds.has(positionId)) {
        throw new Error(
          `Расклад "${spread.id}": повторяющийся position.id "${positionId}"`
        );
      }

      positionIds.add(positionId);
    });
  });
};

validateSpreadsData(spreadsData);
